// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors"; // Store Custom Code
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
// import { PromotionModel } from "@insite/client-framework/Types/ApiModels"; // Store Custom Code
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import CartLineNotes, { CartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes";
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
// import { connect } from "react-redux"; // Store Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { productLineProps } from "@store/Themes/common/props/productLine";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { BadgeModel, CartLineModel, PromotionModel } from "@insite/client-framework/Types/ApiModels";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import Select from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import updateFromWarehouseSrcNames from "@store/Framework/Store/Store/Pages/CheckoutReviewAndSubmit/Handlers/UpdateFromWarehouseSrcNames";
import updateWarehousesPickTypes from "@store/Framework/Store/Store/Pages/CheckoutReviewAndSubmit/Handlers/UpdateWarehousesPickTypes";
import updateWarehousesSourcingTypes from "@store/Framework/Store/Store/Pages/CheckoutReviewAndSubmit/Handlers/UpdateWarehousesSourcingTypes";
import ReturnPolicy from "@store/Library/Components/Icons/ReturnPolicy";
import { hasInvalidConfigurationOption as hasInvalidConfigurationOptionUtil } from "@store/Framework/Common/Utilities/invalidConfigurationUtils";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { connect, ResolveThunks } from "react-redux";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
/* Store Custom Code - End */

interface OwnProps {
    cart: Cart;
    promotions?: PromotionModel[];
    showSavingsAmount: boolean;
    showSavingsPercent: boolean;
    editable: boolean;
    showInvalidPriceMessage?: boolean;
    extendedStyles?: CartLineCardExpandedStyles;
    // Starter Custom Code
    overridedStyles?: CartLineCardExpandedStyles;
}

/* Store Custom Code - Start */
const mapDispatchToProps = {
    updateCartLine,
    updateWarehousesPickTypes,
    updateWarehousesSourcingTypes,
    updateFromWarehouseSrcNames,
    loadWarehouses,
};
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state); // Store Custom Code
    const isAuthenticated = session.isAuthenticated && !session.isGuest; // Store Custom Code
    return {
        enableVat: getSettingsCollection(state).productSettings.enableVat,
        vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
        showPricing: state.context.showPricing,
        isCheckoutReviewAndSubmitPage: getCurrentPage(state).type === "CheckoutReviewAndSubmitPage",
        // Store Custom Code
        isCSOrder: state.store.pages.checkoutReviewAndSubmit.isCSOrder,
        warehousesPickTypes: state.store.pages.checkoutReviewAndSubmit.warehousesPickTypes,
        warehousesSourcingTypes: state.store.pages.checkoutReviewAndSubmit.warehousesSourcingTypes,
        userHasPOSRole: isAuthenticated && (session.userRoles || "").indexOf(constants.roles.pointOfSale) !== -1,
        warehousesDataView: getWarehousesDataView(state, state.components.findLocationModal.getWarehousesParameter),
        availabilityByWarehouse: state.store.pages.checkoutReviewAndSubmit.availabilityByWarehouse,
    };
};

type Props = OwnProps &
    HasCartLineContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>; // Store Custom Code

export interface CartLineCardExpandedStyles {
    cartLineNotes?: CartLineNotesStyles;
    price?: ProductPriceStyles;
    quantity?: CartLineQuantityStyles;
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoContainer?: GridContainerProps;
    productDescriptionAndPartNumbersGridItem?: GridItemProps;
    productDescriptionAndPartNumbersContainer?: GridContainerProps;
    productBrand?: ProductBrandStyles;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productDescription?: ProductDescriptionStyles;
    configurationGridItem?: GridItemProps;
    configurationOptionText?: TypographyProps;
    productPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    orderLineNotesGridItem?: GridItemProps;
    notesHeadingAndText?: SmallHeadingAndTextStyles;
    costCodeGridItem?: GridItemProps;
    costCodeValueText?: TypographyPresentationProps;
    costCodeLabelText?: TypographyPresentationProps;
    productPriceAndQuantityGridItem?: GridItemProps;
    productPriceAndQuantityContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    priceHeadingAndText?: SmallHeadingAndTextStyles;
    promotionNameText?: TypographyProps;
    quantityGridItem?: GridItemProps;
    qtyHeadingAndText?: SmallHeadingAndTextStyles;
    extendedUnitNetPriceGridItem?: GridItemProps;
    extendedUnitNetPrice?: SmallHeadingAndTextStyles;
    subtotalWithoutVatText?: SmallHeadingAndTextStyles;
    vatAmount?: SmallHeadingAndTextStyles;
    cartLineErrorMessageGridItem?: GridItemProps;
    cartLineErrorMessageText?: TypographyProps;
    // Starter Custom Code
    extendedUnitNetPriceLabel?: TypographyPresentationProps;
    extendedUnitNetPriceText?: TypographyPresentationProps;
    subtotalWithoutVat?: TypographyPresentationProps;
    vatLabelText?: TypographyPresentationProps;
    cartLineErrorMessageInfosBox?: InfosBoxProps;
    // Store Custom Code
    returnPolicyMessageInfosBox?: InfosBoxProps;
    returnPolicyMessageHeading?: TypographyProps;
    returnPolicyMessageText?: TypographyProps;
    warehouseSelectorBox?: InjectableCss;
    warehouseSelectorContainer?: GridContainerProps;
    warehouseSelectorGridItem?: GridItemProps;
    sourcingTypeGridItem?: GridItemProps;
}

export const cartLineCardExpandedStyles: CartLineCardExpandedStyles = {
    container: productLineProps.container,
    productImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    orderLineInfoGridItem: productLineProps.contentGridItem,
    orderLineInfoContainer: productLineProps.contentContainer,
    productDescriptionAndPartNumbersGridItem: productLineProps.infoGridItem,
    productDescriptionAndPartNumbersContainer: productLineProps.infoContainer,
    productBrandAndDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrand: productLineProps.brand,
    productDescription: productLineProps.description,
    productPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    configurationGridItem: productLineProps.configurationGridItem,
    configurationOptionText: productLineProps.configuration,
    costCodeGridItem: productLineProps.costCodeGridItem,
    costCodeLabelText: productLineProps.costCodeLabel,
    costCodeValueText: productLineProps.costCodeText,
    productPriceAndQuantityGridItem: productLineProps.pricingGridItem,
    productPriceAndQuantityContainer: productLineProps.pricingContainer,
    priceGridItem: productLineProps.priceGridItem,
    price: productLineProps.price,
    promotionNameText: productLineProps.promotion,
    quantityGridItem: productLineProps.quantityGridItem,
    quantity: productLineProps.quantity,
    extendedUnitNetPriceGridItem: productLineProps.subtotalGridItem,
    extendedUnitNetPriceLabel: productLineProps.subtotalLabel,
    extendedUnitNetPriceText: productLineProps.subtotalValue,
    subtotalWithoutVat: productLineProps.subtotalSecondValue,
    vatLabelText: productLineProps.subtotalVatLabel,
    cartLineErrorMessageGridItem: productLineProps.messageGridItem,
    cartLineErrorMessageInfosBox: productLineProps.messageInfosBox,
    // Store Custom Code
    returnPolicyMessageInfosBox: {
        extendedStyles: {
            wrapper: {
                css: spacingStyles(pxToRem(15), null),
            },
            color: "text",
            backgroundColor: "primary.contrast",
            icon: {
                src: ReturnPolicy,
            },
            border: {
                color: "warning",
                radius: "5",
                style: "solid",
                width: "2",
            },
        },
    },
    returnPolicyMessageHeading: {
        as: "p",
        weight: "bold",
    },
    returnPolicyMessageText: {
        as: "p",
    },
    warehouseSelectorBox: {
        css: css`
            width: 100%;
            margin-top: ${pxToRem(8)};
            background-color: ${getColor("common.accent")};
            padding: ${pxToRem(16)};
        `,
    },
    warehouseSelectorContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([16]), pxToRemArray([10]))}
        `,
    },
    warehouseSelectorGridItem: {
        width: 12,
    },
    sourcingTypeGridItem: productLineProps.infoGridItem,
};

const CartLineCardExpanded = ({
    cart,
    cartLine,
    showSavingsAmount,
    showSavingsPercent,
    promotions,
    editable,
    enableVat,
    vatPriceDisplay,
    showInvalidPriceMessage,
    showPricing,
    isCheckoutReviewAndSubmitPage,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
    // Store Custom Code
    userHasPOSRole,
    updateWarehousesPickTypes,
    warehousesSourcingTypes,
    updateWarehousesSourcingTypes,
    loadWarehouses,
    warehousesDataView,
    isCSOrder,
    warehousesPickTypes,
    updateFromWarehouseSrcNames,
    availabilityByWarehouse,
}: Props) => {
    const { type } = useCurrentPage();
    const styles = useExpandProps(cartLineCardExpandedStyles, extendedStyles, overridedStyles); // Starter Custom Code
    /* Store Custom Code - Start */
    const textBadges: BadgeModel[] = cartLine.properties.badges ? JSON.parse(cartLine.properties.badges) : [];
    const hasInvalidConfigurationOption = hasInvalidConfigurationOptionUtil(cartLine);
    const [whsePickType, setWhsePickType] = React.useState<string>(cartLine.properties.whsePickType || "Counter");
    const [whseSourcingType, setWhseSourcingType] = React.useState<string>(cartLine.properties.sourcingType || "");
    const [fromWarehouseSrcName, setFromWarehouseSrcName] = React.useState<string>(
        cartLine.properties.fromWarehouseSrcName || "",
    );
    const [showWhsePickTypeErrorText, setShowWhsePickTypeErrorText] = React.useState<boolean>(false);
    const canSourceOrder = React.useMemo(() => {
        return cart?.properties?.canSourceOrder === "True";
    }, [cart]);
    const canCounterSales = React.useMemo(() => {
        return cart?.properties?.canCounterSales === "True";
    }, [cart]);
    const sourcingTypes = React.useMemo(() => {
        return cart.properties.sourcingTypes?.split(",");
    }, [cartLine.properties.sourcingTypes]);

    const availableWhsePickTypes = React.useMemo(() => {
        return JSON.parse(cartLine.properties.availableWhsePickTypes);
    }, [cartLine.properties.availableWhsePickTypes]);

    const shouldEmptyWarehouseFieldValues = [
        constants.sourcingTypes.directPurchaseOrder,
        constants.sourcingTypes.warehousePurchaseOrder,
        "",
    ];
    React.useEffect(() => {
        if (sourcingTypes && sourcingTypes.length > 0) {
            if (!warehousesDataView.value && !warehousesDataView.isLoading) {
                const defaultLat = constants.geolocation.defaultLat;
                const defaultLong = constants.geolocation.defaultLong;
                loadWarehouses({
                    search: "",
                    latitude: defaultLat,
                    longitude: defaultLong,
                    radius: 0,
                    sort: "Distance",
                });
                return;
            }
            const existingWarehousesSourcingTypesIndex = warehousesSourcingTypes.findIndex(
                item => item.name === cartLine.id,
            );
            const currentWarehousesSourcingType = warehousesSourcingTypes[existingWarehousesSourcingTypesIndex];
            if (currentWarehousesSourcingType && currentWarehousesSourcingType.value !== whseSourcingType) {
                setWhseSourcingType(cartLine.properties.whseSourcingType || currentWarehousesSourcingType.value);
            }
            if (canSourceOrder) {
                updateWarehousesSourcingTypes({ name: cartLine.id, value: whseSourcingType });
            }
        }

        if (!canCounterSales || !isCSOrder) {
            setWhsePickType("");
            updateWarehousesPickTypes({ name: cartLine.id, value: "" });
        } else if (availableWhsePickTypes.length > 0) {
            const existingWarehousesPickTypesIndex = warehousesPickTypes.findIndex(item => item.name === cartLine.id);
            const currentWarehousesPickType = warehousesPickTypes[existingWarehousesPickTypesIndex];
            if (currentWarehousesPickType && currentWarehousesPickType.value !== whsePickType) {
                setWhsePickType(cartLine.properties.whsePickType || currentWarehousesPickType.value);
            }
            updateWarehousesPickTypes({ name: cartLine.id, value: whsePickType });
        }
        if (!canSourceOrder) {
            setFromWarehouseSrcName("");
            updateFromWarehouseSrcNames({
                name: cartLine.id,
                value: "",
            });
            setWhseSourcingType("");
            updateWarehousesSourcingTypes({ name: cartLine.id, value: "" });
        } else if (sourcingTypes && sourcingTypes.length > 0) {
            const existingWarehousesSourcingTypesIndex = warehousesSourcingTypes.findIndex(
                item => item.name === cartLine.id,
            );
            const currentWarehousesSourcingType = warehousesSourcingTypes[existingWarehousesSourcingTypesIndex];
            const currentSourcingType = cartLine.properties.whseSourcingType || currentWarehousesSourcingType?.value;
            if (currentWarehousesSourcingType && currentWarehousesSourcingType.value !== whseSourcingType) {
                setWhseSourcingType(currentSourcingType);
            }

            if (canSourceOrder) {
                updateWarehousesSourcingTypes({ name: cartLine.id, value: whseSourcingType });
            }

            const shouldEmptyWarehouseField = shouldEmptyWarehouseFieldValues.includes(currentSourcingType);
            if (shouldEmptyWarehouseField) {
                setFromWarehouseSrcName("");
                updateFromWarehouseSrcNames({
                    name: cartLine.id,
                    value: "",
                });
            }
        }

        /* Custom Parameters are saved in batch by CheckoutReviewAndSubmitPlaceOrderButton */
    }, [cartLine, isCSOrder, userHasPOSRole, warehousesDataView]);

    const handleSourcingTypesChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const sourcingType = event.currentTarget.value;
        const shouldEmptyWarehouseField = shouldEmptyWarehouseFieldValues.includes(sourcingType);
        if (shouldEmptyWarehouseField) {
            setFromWarehouseSrcName("");
            updateFromWarehouseSrcNames({
                name: cartLine.id,
                value: "",
            });
        }

        if (sourcingType || sourcingType === "") {
            setWhseSourcingType(sourcingType);
            const localCartLine: CartLineModel = JSON.parse(JSON.stringify(cartLine)) as CartLineModel;
            if (!localCartLine.properties) {
                localCartLine.properties = {};
            }
            localCartLine.properties.sourcingType = sourcingType;
            updateWarehousesSourcingTypes({ name: localCartLine.id, value: localCartLine.properties.sourcingType });
        } else {
            setShowWhsePickTypeErrorText(true);
        }
    };
    const handlefromWarehouseSrcNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const fromWarehouseSrcName = event.currentTarget.value;
        if (fromWarehouseSrcName || fromWarehouseSrcName === "") {
            setFromWarehouseSrcName(fromWarehouseSrcName);
            const localCartLine: CartLineModel = JSON.parse(JSON.stringify(cartLine)) as CartLineModel;
            if (!localCartLine.properties) {
                localCartLine.properties = {};
            }
            localCartLine.properties.fromWarehouseSrcName = fromWarehouseSrcName;
            updateFromWarehouseSrcNames({
                name: localCartLine.id,
                value: localCartLine.properties.fromWarehouseSrcName,
            });
        } else {
            setShowWhsePickTypeErrorText(true);
        }
    };
    const handleWhsePickTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const warehouseType = event.currentTarget.value;
        if (warehouseType || warehouseType === "") {
            setWhsePickType(warehouseType);
            const localCartLine: CartLineModel = JSON.parse(JSON.stringify(cartLine)) as CartLineModel;
            if (!localCartLine.properties) {
                localCartLine.properties = {};
            }
            localCartLine.properties.whsePickType = warehouseType;
            updateWarehousesPickTypes({ name: localCartLine.id, value: localCartLine.properties.whsePickType });
        } else {
            setShowWhsePickTypeErrorText(true);
        }
    };

    const getProductQuantityByWarehouse = (warehouseName: string, productErpNumber: string) => {
        if (!availabilityByWarehouse) {
            return;
        }

        const whsProductQuantites =
            availabilityByWarehouse[availabilityByWarehouse.findIndex(w => w.warehouseName === warehouseName)];

        if (!whsProductQuantites) {
            return "0";
        }

        return whsProductQuantites.productsQuantities[
            whsProductQuantites.productsQuantities.findIndex((p: any) => p.productSku === productErpNumber)
        ].quantity;
    };

    /* Store Custom Code - End */
    return (
        <GridContainer
            {...styles.container}
            data-test-selector={`cartline_expanded_${cartLine.productId}_${cartLine.unitOfMeasure}`}
        >
            {/* Starter Custom Code - Start */}
            {(cartLine.isRestricted || !cartLine.isActive) && (
                <GridItem {...styles.cartLineErrorMessageGridItem}>
                    {cartLine.isRestricted && (
                        <InfosBox
                            {...styles.cartLineErrorMessageInfosBox}
                            data-test-selector="cartline_restrictedMessage"
                        >
                            {translate("Restricted product")}
                        </InfosBox>
                    )}
                    {!cartLine.isActive && (
                        <InfosBox
                            {...styles.cartLineErrorMessageInfosBox}
                            data-test-selector="savedordercartline_inactiveErrorMessage"
                        >
                            {translate("Inactive Product")}
                        </InfosBox>
                    )}
                </GridItem>
            )}
            {/* Starter Custom Code - End */}
            <GridItem {...styles.productImageGridItem}>
                <ProductImage product={cartLine} extendedStyles={styles.productImage} />
            </GridItem>
            <GridItem {...styles.orderLineInfoGridItem}>
                <GridContainer {...styles.orderLineInfoContainer}>
                    <GridItem {...styles.productDescriptionAndPartNumbersGridItem}>
                        <GridContainer {...styles.productDescriptionAndPartNumbersContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {cartLine.brand && (
                                    <ProductBrand brand={cartLine.brand} extendedStyles={styles.productBrand} />
                                )}
                                <ProductDescription product={cartLine} extendedStyles={styles.productDescription} />
                            </GridItem>
                            {/* Starter Custom Code - Start */}
                            <GridItem {...styles.productPartNumbersGridItem}>
                                <ProductPartNumbers
                                    productNumber={cartLine.erpNumber}
                                    customerProductNumber={cartLine.customerName}
                                    manufacturerItem={cartLine.manufacturerItem}
                                    extendedStyles={styles.productPartNumbers}
                                />
                            </GridItem>
                            {/* Store Custom Code - Start */}
                            <GridItem {...styles.productPartNumbersGridItem}>
                                {type !== constants.pageType.checkoutReviewAndSubmit &&
                                    canSourceOrder &&
                                    cart.properties.sourcingTypes &&
                                    warehousesDataView.value && (
                                        <StyledWrapper>
                                            {cartLine.properties.sourcingType && (
                                                <StyledWrapper>
                                                    <Typography {...styles.extendedUnitNetPriceLabel}>
                                                        {translate("Sourcing Type")}:{" "}
                                                    </Typography>
                                                    <Typography>{cartLine.properties.sourcingType}</Typography>
                                                </StyledWrapper>
                                            )}
                                            {cartLine.properties.fromWarehouseSrcName && (
                                                <StyledWrapper>
                                                    <Typography {...styles.extendedUnitNetPriceLabel}>
                                                        {translate("From Warehouse")}:
                                                    </Typography>
                                                    <Typography>{cartLine.properties.fromWarehouseSrcName}</Typography>
                                                </StyledWrapper>
                                            )}
                                        </StyledWrapper>
                                    )}
                            </GridItem>
                            {(textBadges.length > 0 ||
                                cartLine.properties.isScratchAndDent?.toLowerCase() === "true") && (
                                <GridItem {...styles.productPartNumbersGridItem}>
                                    {textBadges.length > 0 && (
                                        <ProductTextBadges badgeList={textBadges} maxBadges={4} />
                                    )}
                                    {cartLine.properties.isScratchAndDent?.toLowerCase() === "true" && (
                                        <InfosBox
                                            data-test-selector="returnPolicy_Message"
                                            {...styles.returnPolicyMessageInfosBox}
                                        >
                                            <Typography {...styles.returnPolicyMessageHeading}>
                                                {translate("returnPolicyMessageHeading")}
                                            </Typography>
                                            <Typography {...styles.returnPolicyMessageText}>
                                                {translate("returnPolicyMessageText")}
                                            </Typography>
                                        </InfosBox>
                                    )}
                                </GridItem>
                            )}
                            {/* Store Custom Code - End */}
                            {/* Starter Custom Code - End */}
                            {!cartLine.isFixedConfiguration && cartLine.sectionOptions!.length > 0 && (
                                <GridItem {...styles.configurationGridItem}>
                                    {cartLine.sectionOptions!.map(option => (
                                        <Typography {...styles.configurationOptionText} key={option.sectionOptionId}>
                                            {`${option.sectionName}:${option.optionName}`}
                                        </Typography>
                                    ))}
                                </GridItem>
                            )}
                            {/* Store Custom Code - Start */}
                            {hasInvalidConfigurationOption && (
                                <GridItem {...styles.configurationGridItem}>
                                    <InfosBox
                                        {...styles.cartLineErrorMessageInfosBox}
                                        type="warning"
                                        data-test-selector="cartline_invalidConfigurationWarning"
                                    >
                                        <Typography {...styles.cartLineErrorMessageText}>
                                            {translate("Cart_InvalidConfigurationLineMsg")}
                                        </Typography>
                                    </InfosBox>
                                </GridItem>
                            )}
                            {/* Store Custom Code - End */}
                            {/* Starter Custom Code - Start */}
                            {cart.showCostCode && cartLine.costCode && (
                                <GridItem {...styles.costCodeGridItem} data-test-selector="orderConformation_CostCode">
                                    <Typography {...styles.costCodeLabelText}>{cart.costCodeLabel}</Typography>
                                    <Typography {...styles.costCodeValueText}>{cartLine.costCode}</Typography>
                                </GridItem>
                            )}
                            {/* Starter Custom Code - End */}
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.productPriceAndQuantityGridItem}>
                        <GridContainer {...styles.productPriceAndQuantityContainer}>
                            {(showPricing || isCheckoutReviewAndSubmitPage) /* Starter Custom Code */ && (
                                <GridItem {...styles.priceGridItem}>
                                    <ProductPrice
                                        product={cartLine}
                                        showSavings={true}
                                        showSavingsAmount={showSavingsAmount}
                                        showSavingsPercent={showSavingsPercent}
                                        showInvalidPriceMessage={showInvalidPriceMessage}
                                        extendedStyles={styles.price}
                                    />
                                    {/* Starter Custom Code - Start */}
                                    {promotions && promotions.length > 0 && (
                                        <Typography
                                            {...styles.promotionNameText}
                                            data-test-selector="orderLineCardExpandedPromotionName"
                                        >
                                            {translate("{0}:", translate("Promotions"))}{" "}
                                            {promotions.map(x => x.name).join(", ")}
                                        </Typography>
                                    )}
                                    {/* Starter Custom Code - End */}
                                </GridItem>
                            )}
                            <GridItem {...styles.quantityGridItem} data-test-selector="orderConformation_Quantity">
                                <CartLineQuantity cart={cart} editable={editable} extendedStyles={styles.quantity} />
                            </GridItem>
                            {/* Starter Custom Code - Start */}
                            {cartLine.pricing && (showPricing || isCheckoutReviewAndSubmitPage) && (
                                <GridItem {...styles.extendedUnitNetPriceGridItem}>
                                    <Typography {...styles.extendedUnitNetPriceLabel}>
                                        {translate("Subtotal")}
                                    </Typography>
                                    <Typography {...styles.extendedUnitNetPriceText}>
                                        {enableVat && vatPriceDisplay !== "DisplayWithoutVat"
                                            ? cartLine.pricing.extendedUnitRegularPriceWithVatDisplay
                                            : cartLine.pricing.extendedUnitNetPriceDisplay}
                                    </Typography>
                                    {enableVat && (
                                        <>
                                            <Typography {...styles.vatLabelText}>
                                                {vatPriceDisplay === "DisplayWithVat" ||
                                                vatPriceDisplay === "DisplayWithAndWithoutVat"
                                                    ? `${translate("Inc. VAT")} (${cartLine.pricing.vatRate}%)`
                                                    : translate("Ex. VAT")}
                                            </Typography>
                                            {vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                                <>
                                                    <Typography {...styles.subtotalWithoutVat}>
                                                        {cartLine.pricing.extendedUnitNetPriceDisplay}
                                                    </Typography>
                                                    <Typography {...styles.vatLabelText}>
                                                        {translate("Ex. VAT")}
                                                    </Typography>
                                                </>
                                            )}
                                        </>
                                    )}
                                </GridItem>
                            )}
                            {/* Starter Custom Code - End */}
                        </GridContainer>
                    </GridItem>
                    {/* Store Custom Code - Start */}
                    {/* Manage Sourcing Type */}
                    {type === constants.pageType.checkoutReviewAndSubmit &&
                        canSourceOrder &&
                        cart.properties.sourcingTypes &&
                        warehousesDataView.value && (
                            <GridItem {...styles.sourcingTypeGridItem}>
                                {cart.properties.sourcingTypes && (
                                    <Select
                                        value={whseSourcingType}
                                        onChange={handleSourcingTypesChange}
                                        disabled={type !== constants.pageType.checkoutReviewAndSubmit}
                                        label={translate("Sourcing Type")}
                                        data-test-selector="sourcingTypeSelect"
                                        required={!!(!whseSourcingType && fromWarehouseSrcName)}
                                    >
                                        <option value="">{translate("sourcingTypes_select_placeholder")}</option>
                                        {cart.properties.sourcingTypes?.split(",").map(sourcingType => {
                                            if (
                                                cartLine.properties.isCanPurchaseOrder &&
                                                cartLine.properties.isCanPurchaseOrder.toLowerCase() === "false"
                                            ) {
                                                if (
                                                    [
                                                        constants.sourcingTypes.directPurchaseOrder,
                                                        constants.sourcingTypes.warehousePurchaseOrder,
                                                    ].includes(sourcingType)
                                                ) {
                                                    return null;
                                                }
                                            }
                                            return (
                                                <option key={sourcingType} value={sourcingType}>
                                                    {sourcingType}
                                                </option>
                                            );
                                        })}
                                    </Select>
                                )}
                                &nbsp;
                                {[
                                    constants.sourcingTypes.warehouseTransfer,
                                    constants.sourcingTypes.directTransfer,
                                ].includes(whseSourcingType) &&
                                    cart.properties.sourcingTypes &&
                                    warehousesDataView.value && (
                                        <Select
                                            value={fromWarehouseSrcName}
                                            onChange={handlefromWarehouseSrcNameChange}
                                            data-test-selector="sourcingWarehouseSelect"
                                            label={translate("From Warehouse")}
                                            required={!!(whseSourcingType && !fromWarehouseSrcName)}
                                        >
                                            <option value="">
                                                {translate("sourcingTypesWarehouse_select_placeholder")}
                                            </option>
                                            {warehousesDataView.value.map(warehouse => (
                                                <option key={warehouse.name} value={warehouse.name}>
                                                    {warehouse.name} - {translate("QTY:")}{" "}
                                                    {getProductQuantityByWarehouse(warehouse.name, cartLine.erpNumber)}
                                                </option>
                                            ))}
                                        </Select>
                                    )}
                            </GridItem>
                        )}

                    {/* Store Custom Code - End */}
                </GridContainer>
                {/* Store Custom Code - Start */}
                {/* Manage Bin Type */}
                {isCSOrder && canCounterSales && availableWhsePickTypes.length > 1 && (
                    <GridContainer {...styles.warehouseSelectorContainer}>
                        <GridItem {...styles.warehouseSelectorGridItem}>
                            <StyledWrapper {...styles.warehouseSelectorBox}>
                                <Select
                                    label={translate("{0}:", translate("whsePickType_select_label"))}
                                    value={whsePickType || "Counter"}
                                    onChange={handleWhsePickTypeChange}
                                    error={showWhsePickTypeErrorText ? translate("whsePickType_required_error") : ""}
                                    disabled={type !== constants.pageType.checkoutReviewAndSubmit}
                                    data-test-selector="orderConformation_whsePickType"
                                    required
                                >
                                    {availableWhsePickTypes.map((method: string) => (
                                        <option key={method} value={method}>
                                            {method}
                                        </option>
                                    ))}
                                </Select>
                            </StyledWrapper>
                        </GridItem>
                    </GridContainer>
                )}
                {/* Store Custom Code - End */}
                {/* Starter Custom Code - Start */}
                {cartLine.notes && (
                    <CartLineNotes
                        cart={cart}
                        editable={editable}
                        label={translate("Line Notes")}
                        extendedStyles={styles.cartLineNotes}
                    />
                )}
                {/* Starter Custom Code - End */}
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withCartLine(CartLineCardExpanded)); // Store Custom Code
